<script setup lang="ts">
import { BenefitsProps } from "./Benefits.props"
import { iconsSrcMap } from "./Benefits.iconMapping"

defineProps<BenefitsProps>()
</script>

<template>
  <div
    class="
      card-benefits
      h-full
      w-[307px]
      rounded-lg
      bg-white
      p-2
      md:w-auto
      md:p-4
    "
  >
    <div class="flex flex-col gap-x-6 gap-y-2">
      <div
        v-if="iconType"
        class="
          relative
          mt-4
          h-8
          w-8
          rounded-full
          bg-yellow-10
          md:mt-6
          md:h-10
          md:w-10
        "
      >
        <UtilsIcon
          class="absolute bottom-1 left-1 h-9 w-auto md:h-11 md:w-auto"
          v-bind="iconsSrcMap[iconType]"
        />
      </div>
      <p
        v-if="title"
        class="
          pig-bold
          md:dolphin-bold
          highlighted-text
          relative
          z-0
          before:bg-tiffany-10
        "
      >
        {{ title }}
      </p>
    </div>
    <UtilsMarkdown
      v-if="description"
      class="
        beaver
        markdown__strong-black-80
        markdown__link-underlined
        markdown__link-bold
        markdown__link-black-80
        mt-3
      "
      :content="description"
    />
  </div>
</template>

<style scoped lang="scss">

.highlighted-text {
  display: inline;
  position: relative;
}

.highlighted-text::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 8px;
  left: 16px;
  right: 0;
  height: 100%;
  z-index: -1;
}

</style>
